import React from 'react'

import { CampaignsCollapseListStyled } from './styles'

const CampaignsCollapseList = ({ onClick }) => (
  <CampaignsCollapseListStyled onClick={onClick}>See less</CampaignsCollapseListStyled>
)

export default CampaignsCollapseList
